import React from 'react';
import PropTypes from 'prop-types';
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from '@progress/kendo-react-buttons';
//import queryString from "query-string";
import { withRouter } from 'react-router';

import { isEmpty, flatten } from '../helpers';
import isPage from '../hoc/isPage';
import Header from '../components/Header';
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';
import GridContainer, { GridContainerToolbar, GridContainerToolbarOption } from '../components/GridContainer';
import { BlankCell, ButtonCell, BooleanCell, DropDownFilterArrayCell/*, DropDownFilterCell*/ } from "../components/utils/GridHelpers";
import AdminEditUserPage from './AdminEditUserPage';
//import config from '../config/config';
import { getRoleID } from '../helpers';
import { AppContext } from '../context/AppContext';
import localize from '../hoc/localize';
//import { capitalize } from '../helpers';

class AdminManageUsersPage extends React.Component {
    static propTypes = {

        // optional; passed in only if we want to view users of a specific org
        org: PropTypes.shape({
            orgID: PropTypes.number,
            orgName: PropTypes.string
        }),
        role: PropTypes.shape({
            roleID: PropTypes.string,
            role: PropTypes.string  // name of role
        }),

        // what mode is the page operating in?
        // options:
        //      admin >> manage users for selected org (manageUsersForSelectedOrg)
        //      admin >> manage superadmins (manageSuperAdmins)
        //      settings >> manage users for user's org (manageUsersForOwnOrg)
        mode: PropTypes.oneOf([
            "manageUsersForSelectedOrg",
            "manageSuperAdmins",
            "manageUsersForOwnOrg"
        ])

        // optional; passed in if we want to view users of a specific role
        //role: PropTypes.string
    }



    // name of the org whose users we are currently editing
    orgName;
    orgID;
    org;

    // if viewing the list of users by role, this indicates the roleID and role name
    roleID;
    role;

    // unique list of all roles in the system
    roles;

    //constructor(props) {
    //    super(props);
    //    //const queryStringParams = queryString.parse(window.location.search);

    //    //console.log('constructor() for AdminManageUsersPeople.js');

    //    // get the name of the org from this.props.org
    //    // if (this.props.org && this.props.org.orgName) {
    //    //     this.orgName = this.props.org.orgName;
    //    //     this.orgID = this.props.org.orgID;
    //    // }
    //    // // get the name of the org from the querystring and the URL
    //    // else {
    //    //     this.orgName = (queryStringParams.orgName) ? queryStringParams.orgName : '';
    //    //     this.orgID = this.props.match.params.orgID;
    //    // }

    //    /*
    //    populate this.org. How? And why?
    //    Why: 
    //        so we can pass this into AdminEditUserPage; so we know what org the user is auto assigned to.
    //    How: 
    //        passed in from the previous page if necessary
    //    */

    //    // get the role filter
    //    // this.roleID = (queryStringParams.roleID) ? queryStringParams.roleID : '';
    //    // this.role = (queryStringParams.role) ? queryStringParams.role : '';
    //    //debugger;
    //}
    state = {
        data: null,
        selectedUser: null, // the user that we want to perform actions on
        showDialog: false, // show the dialog to edit/add users
        showWelcomeEmailConfirmDialog: false // show dialog to confirm whether to send welcome email or not
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.uiLanguage !== this.props.uiLanguage) {
            this.getData();
        }
    }

    handleRefreshListing = () => {
        this.getData();
    }

    parseRoles(roles) {
        var newRoles = roles;
        ///*
        for (let i = 0; i < newRoles.length; i++) {
            switch (newRoles[i]) {
                case "admin":
                    //newRoles[i] = capitalize(this.props.returnLocalizedString("m0571"));
                    newRoles[i] = this.props.returnLocalizedString("m0571");
                    break;
                case "user":
                    //newRoles[i] = capitalize(this.props.returnLocalizedString("m0570"));
                    newRoles[i] = this.props.returnLocalizedString("m0570");
                    break;
                case "superadmin":
                    //newRoles[i] = capitalize(this.props.returnLocalizedString("m0572"));
                    newRoles[i] = this.props.returnLocalizedString("m0572");
                    break;
                default:
                    break;
            }
        }
        //for (var i in newRoles) {
        //    switch (i) {
        //        case "admin":
        //            newRoles[i] = capitalize(this.props.returnLocalizedString("m0571"));
        //            break;
        //        case "user":
        //            newRoles[i] = capitalize(this.props.returnLocalizedString("m0570"));
        //            break;
        //        case "superadmin":
        //            newRoles[i] = capitalize(this.props.returnLocalizedString("m0572"));
        //            break;
        //        default:
        //            break;
        //    }
        //}
        return newRoles;
        //*/
    }

    parseUserRoles(roles) {
        //ar newRoles = []
    }

    getData = () => {

        let apiUrl;
        //console.log('this.props.mode', this.props.mode);
        // api call depends on the mode
        switch (this.props.mode) {
            case "manageUsersForOwnOrg":
                const orgID = this.context.state.orgID;
                // check current role ID
                if (this.context.state.roles.includes("superadmin")) {
                    apiUrl = `/api/portal/admin/org/${orgID}/user/GetList`;
                } else {
                    apiUrl = '/api/portal/admin/user/GetList';
                }
                break;

            case "manageUsersForSelectedOrg":
                // would only be used by superamdin users
                const { org } = this.props;

                apiUrl = `/api/portal/admin/org/${org.orgID}/user/GetList`;
                break;

            case "manageSuperAdmins":
                // get the roleID of the super admin role
                const superAdminRoleID = getRoleID("superadmin");
                if (superAdminRoleID) {

                    // grab just the superadmin users
                    apiUrl = `/api/portal/admin/user/GetList?roleID=${superAdminRoleID}`;
                } else {
                    this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0086"))
                    return;
                }
                break;

            default:
                break;
        }

        ///debugger;
        if (!isEmpty(apiUrl)) {
            this.props.getData(apiUrl)
                .then(({ data }) => {

                    // get unique list of roles
                    var localizedData = data;
                    this.roles = this.parseRoles(Array.from(new Set(flatten(data.map(user => user.roles)))));
                    //console.log(this.roles);
                    //for (var i in localizedData) {
                    //    console.log(localizedData[i].roles);
                    //    localizedData[i].roles = this.parseRoles(localizedData[i].roles);
                    //    console.log(localizedData[i].roles);
                    //}
                    for (let i = 0; i < localizedData.length; i++) {
                        //console.log(localizedData[i].roles);
                        localizedData[i].roles = this.parseRoles(localizedData[i].roles);
                        //console.log(localizedData[i].roles);
                    }
                    this.setState({ data });
                    //console.log(this.state.data);
                })
                .catch(error => {
                    this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0087"));
                })
        } else {
            this.props.alert('error', this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0087"))
        }


    }

    getOrgName() {

    }
    handleAddUserClick = (e) => {
        // show the user modal dialog
        this.setState({
            showDialog: true,
            selectedUser: null
        })
    }
    handleEditUserClick = (e, props) => {
        //debugger;
        const { userID } = props.dataItem

        // open up a dialog to edit the user
        const selectedUser = {
            userID
        }
        this.setState({
            selectedUser,
            showDialog: true
        });

    }
    handleWelcomeEmailClick = (e, props) => {
        const { userID, firstName, lastName, registered } = props.dataItem;
        //console.log('registered', registered);

        // if user record is already registered, then bring up an alert stating that if we send out a welcome email, it's going to reset the subject claim of the user record and the person will no longer be able to log in
        if (registered) {
            this.setState({
                selectedUser: {
                    userID,
                    firstName,
                    lastName
                },
                showWelcomeEmailConfirmDialog: true
            });
        } else {
            this.setState({
                selectedUser: {
                    userID,
                    firstName,
                    lastName
                }
            }, () => {
                this.handleSendWelcomeEmail(this.state.selectedUser);
            });

        }
        //this.props.alert("info", this.props.returnLocalizedString("m0072"), this.props.returnLocalizedString("m0073", "", user.firstName, user.lastName));
    }
    handleSendWelcomeEmail = (user) => {

        const userID = user.userID;
        const uiLanguage = this.props.uiLanguage;
        // first must reset the user's subject claim

        this.props.postData('/api/portal/admin/user/ResetSubjectClaim', {
            userID
        }).then(response => {
            //console.log("Reset the user's subject claim ...")

            // now let's send the welcome email
            // fire the endpoint /api/portal/admin/user/SendWelcomeEmail?userID=
            this.props.postData(`/api/portal/admin/user/${userID}/SendWelcomeEmail?uiLanguage=${uiLanguage}`).then(() => {
                this.props.alert("info", this.props.returnLocalizedString("m0072"), '🚀 ' + this.props.returnLocalizedString("m0073", "", user.firstName, user.lastName));
            }).catch((error) => {
                this.props.alert("error", this.props.returnLocalizedString("m0023"), error.response.data);
                //console.log(error.response.data);
            })


        }).catch(error => {

            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0088"))
        })


    }
    handleCloseModal = () => {
        this.setState({
            showDialog: false,
            showWelcomeEmailConfirmDialog: false
        })
    }

    //!DBTRANS! @m0004@ Home !DEVNOTE! Page Name
    //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
    //!DBTRANS! @m0086@ Unable to retrieve list of super admins. !DEVNOTE! Action status
    //!DBTRANS! @m0087@ There was a problem in fetching the list of users. Please try again. !DEVNOTE! Action status
    //!DBTRANS! @m0088@ We failed to send out the email. Please try again. !DEVNOTE! Action status
    //!DBTRANS! @m0089@ Manage Users !DEVNOTE! Action Label
    //!DBTRANS! @m0090@ Manage Orgs !DEVNOTE! Action Label
    //!DBTRANS! @m0091@ Manage Users for %var1% !DEVNOTE! Action Label
    //!DBTRANS! @m0092@ Manage Users with the role %var1% !DEVNOTE! Action Label
    //!DBTRANS! @m0093@ Create New User !DEVNOTE! Action Label
    //!DBTRANS! @m0094@ Role !DEVNOTE! Table Column Label
    //!DBTRANS! @m0095@ Inactive !DEVNOTE! Table Column Label
    //!DBTRANS! @m0096@ Registered !DEVNOTE! Table Column Label
    //!DBTRANS! @m0097@ Edit User !DEVNOTE! Action Button Text
    //!DBTRANS! @m0098@ Send Welcome Email !DEVNOTE! Action Button Text
    //!DBTRANS! @m0099@ Are you sure you want to send a welcome email to  %var1% %var2%? !DEVNOTE! New User Email Dialog Text
    //!DBTRANS! @m0100@ This person will be forced to re-register for an account. Until then his/her access to SOM will be taken away. !DEVNOTE! New User Email Dialog Text
    //!DBTRANS! @m0101@ Cancel !DEVNOTE! New User Email Dialog Button

    render() {
        let tabs;
        let previousPageTitle;
        let previousPageUrl;
        const { mode } = this.props;

        //// present option to see list of all orgs only if we are currently viewing users for a *selected org*
        //if (mode === "manageUsersForSelectedOrg") {
        //    tabs = (
        //        <Tabs>
        //            <Tab label="Go back to list of orgs" link="/admin" ></Tab>
        //        </Tabs>);
        //    previousPageTitle = "Admin";
        //    previousPageUrl = "/admin";
        //}



        let title = '';
        const { org, role } = this.props;

        if (mode === "manageUsersForOwnOrg") {
            tabs = (<Tabs>
                <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
                <Tab label={this.props.returnLocalizedString("m0089")} ></Tab>
            </Tabs>);
            title = this.props.returnLocalizedString("m0089")
        } else if (mode === "manageUsersForSelectedOrg") {
            // present option to see list of all orgs only if we are currently viewing users for a *selected org*
            tabs = (<Tabs>
                <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
                <Tab label={this.props.returnLocalizedString("m0090")} link="/admin" ></Tab>
                <Tab label={this.props.returnLocalizedString("m0091", "", org.orgName)} ></Tab>
            </Tabs>);
            //previousPageTitle = "Admin";
            //previousPageUrl = "/admin";
            title = this.props.returnLocalizedString("m0091", "", org.orgName);
        } else if (role) {
            tabs = (<Tabs>
                <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
                <Tab label={this.props.returnLocalizedString("m0092", "", role.role)} ></Tab>
            </Tabs>);
            title = this.props.returnLocalizedString("m0092", "", role.role);
        }

        // if (org) {
        //     title = `Manage Users for ${org.orgName}`;
        // } else if (role) {
        //     title = `Manage Users with the role ${role.role}`;
        // }

        //!DBTRANS! @m0569@ (All) !DEVNOTE! Grid option Label 
        //!DBTRANS! @m0570@ User !DEVNOTE! 
        //!DBTRANS! @m0571@ Admin !DEVNOTE! 
        //!DBTRANS! @m0572@ Superadmin !DEVNOTE! 

        return (
            <div>
                <Header title={title} tabs={tabs} previousPageTitle={previousPageTitle} previousPageUrl={previousPageUrl} />

                <section className="page-content-padding-top-70 grid-row">
                    {this.state.data && (
                        <GridContainer
                            data={this.state.data}
                            sortColumn="firstName"
                            filterable={true}
                            pageable={true}
                            pageSizes={[5, 10, 20]}
                            pageSize={10}
                        >
                            <GridContainerToolbar>
                                <GridContainerToolbarOption type="add" tooltip="m0093" primary={true} handleClick={this.handleAddUserClick} />
                            </GridContainerToolbar>
                            <Column width="250px" field="firstName" title={this.props.returnLocalizedString("m0078")} />
                            <Column width="250px" field="lastName" title={this.props.returnLocalizedString("m0079")} />

                            {this.props.mode !== "manageSuperAdmins" && (
                                <Column width="250px" field="roles" title={this.props.returnLocalizedString("m0094")} cell={(props) => {
                                    return (
                                        <td style={{ textTransform: 'capitalize' }}>
                                            {props.dataItem[props.field].join(', ')}
                                        </td>
                                    );
                                }} filterCell={(props) => <DropDownFilterArrayCell data={this.roles} defaultItem={this.props.returnLocalizedString("m0569")} {...props} />} />
                            )}
                            <Column width="150px" field="inactive" title={this.props.returnLocalizedString("m0095")} filter="boolean" cell={(props) =>
                                <BooleanCell {...props} />
                            } />
                            <Column width="150px" field="registered" title={this.props.returnLocalizedString("m0096")} filter="boolean" cell={(props) =>
                                <BooleanCell {...props} />
                            } />

                            <Column width={`${this.props.returnLocalizedString("m0097").length * 8 + 36}px`}
                                filterable={false}
                                sortable={false}
                                reorderable={false}
                                cell={(props) => <ButtonCell text={this.props.returnLocalizedString("m0097")} handleClick={(e) => { this.handleEditUserClick(e, props) }} />}
                                editable={false}
                            />
                            <Column width={`${this.props.returnLocalizedString("m0098").length * 8 + 36}px`}
                                filterable={false}
                                sortable={false}
                                reorderable={false}
                                cell={(props) => <ButtonCell disabled={props.dataItem.userID === this.context.state.userID} text={this.props.returnLocalizedString("m0098")} handleClick={(e) => { this.handleWelcomeEmailClick(e, props) }} />}
                                editable={false}
                            />
                            <Column
                                filterable={false}
                                resizable={false}
                                sortable={false}
                                reorderable={false}
                                cell={(props) => (
                                    <BlankCell {...props} />
                                )}
                                editable={false}
                            />

                        </GridContainer>)}

                </section>

                {this.state.showDialog && (
                    <Dialog
                        width={"60%"}
                        minWidth={320}
                        closeIcon={false}
                    >
                        <AdminEditUserPage
                            handleCloseModal={this.handleCloseModal}
                            handleRefreshListing={this.handleRefreshListing}
                            mode={this.props.mode}
                            org={org}
                            role={role}
                            user={this.state.selectedUser} />
                    </Dialog>)}

                {this.state.showWelcomeEmailConfirmDialog && (
                    <Dialog width={"60%"}
                        minWidth={320}
                    >

                        <SendWelcomeEmailConfirmDialogLocalize
                            user={this.state.selectedUser}
                            handleSendWelcomeEmail={this.handleSendWelcomeEmail}
                            // fire the endpoint /api/portal/admin/
                            handleCloseModal={this.handleCloseModal}
                        />
                    </Dialog>
                )
                }
            </div>
        )

    }
}
export default withRouter(isPage(AdminManageUsersPage));
AdminManageUsersPage.contextType = AppContext;

const SendWelcomeEmailConfirmDialog = (props) => {
    return (
        <React.Fragment>
            <div className="bottom-margin-20">
                <p>{props.returnLocalizedString("m0099", "", props.user.firstName, props.user.lastName)}</p>
                <p>{props.returnLocalizedString("m0100")}</p>
            </div>
            <Button primary={true} style={{ 'border': '1px' }} className="right-margin-20" onClick={() => { props.handleSendWelcomeEmail(props.user); props.handleCloseModal(); }}>Send welcome email</Button>
            <Button onClick={() => { props.handleCloseModal() }}>{props.returnLocalizedString("m0101")}</Button>
        </React.Fragment>
    )
}

const SendWelcomeEmailConfirmDialogLocalize = localize(SendWelcomeEmailConfirmDialog);

SendWelcomeEmailConfirmDialog.propTypes = {
    user: PropTypes.shape({
        userID: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string
    }),
    handleSendWelcomeEmail: PropTypes.func,
    // fire the endpoint /api/portal/admin/
    handleCloseModal: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/containers/AdminManageUsersPage.js